export const LOCAL_STORAGE_KEYS = {
  COUNT_DOWN_END_TIME: 'countdownEndTime'
};
